// extracted by mini-css-extract-plugin
export default {"rightInitial":"rightInitial-3r1-6"};